const MEDIA_BREAKPOINTS = {
    sm: [0, 767],
    md: [768, 991],
    lg: [992, 1279],
    xl: [1280, 99999],
};

export default MEDIA_BREAKPOINTS;